import { Card, Col, Divider, Flex, Row, Typography } from 'antd';

const { Title } = Typography;

const InfoCards = ({
    items = [],
    maxColumns = 4,
}) => {
    const colSpan = 24 / maxColumns;
    
    return (
        <>
            <Row gutter={[10, 10]} wrap="wrap">
                {items?.map((item, idx) => (
                    <Col key={idx} xs={24} md={12} lg={12} xl={colSpan}>
                        <Card
                            style={{
                                flex: "1 1 200px",
                                minWidth: "180px",
                                borderRadius: "6px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                            }}
                            styles={{
                                body: {
                                    padding: "16px"
                                }
                            }}
                        >
                            <Flex justify="space-between" align="center" wrap>
                                <Title ellipsis={{ tooltip: item?.label }} level={5} style={{ margin: 0, fontWeight: 'normal' }}>{item?.label}</Title>
                                <Divider type="vertical" style={{ background: 'gray' }} />
                                <Title ellipsis={{ tooltip: item?.value }} level={4} style={{ margin: 0 }}>
                                    {item.value}
                                </Title>
                            </Flex>
                        </Card>
                    </Col>
                ))}
            </Row>
            <Divider style={{ margin: '16px 0' }} />
        </>
    )
}

export default InfoCards